registerBlockType( 'tornado/hero-slider', {
    title: 'Hero Slider',
    description: __('Home Page Slider Dynamic Block', 'tornado'),
    icon:'editor-insertmore',
    category:'tornado',
    keywords: [ 'slider', 'tornado', 'home' ],
    supports: {
        align: ['full','wide']
    },
    attributes : {},
    //==== Edit Mode ====//
    edit: props => {
        const { attributes, setAttributes } = props;
        props.setAttributes( { align: 'full' } );
        // Rendering in PHP
        return (
            <Panel>
                <PanelBody>
                    {/* {heroSlider()} */}
                    <ServerSideRender block="tornado/hero-slider" />
                    {attributes.align === 'full'}
                </PanelBody>
            </Panel>
        )
    },

    save() { // Rendering in PHP
        return null;
    },
});